function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.667969 2.99984C0.667969 2.81574 0.817207 2.6665 1.0013 2.6665H13.0013C13.1854 2.6665 13.3346 2.81574 13.3346 2.99984C13.3346 3.18393 13.1854 3.33317 13.0013 3.33317H1.0013C0.817207 3.33317 0.667969 3.18393 0.667969 2.99984Z",
  fill: "#666666"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.66667 0.666667C5.40145 0.666667 5.1471 0.772023 4.95956 0.95956C4.77202 1.1471 4.66667 1.40145 4.66667 1.66667V2.66667H9.33333V1.66667C9.33333 1.40145 9.22798 1.1471 9.04044 0.95956C8.8529 0.772023 8.59855 0.666667 8.33333 0.666667H5.66667ZM10 2.66667V1.66667C10 1.22464 9.82441 0.800716 9.51185 0.488155C9.19929 0.175595 8.77536 0 8.33333 0H5.66667C5.22464 0 4.80072 0.175595 4.48816 0.488155C4.1756 0.800716 4 1.22464 4 1.66667V2.66667H2.33333C2.14924 2.66667 2 2.81591 2 3V12.3333C2 12.7754 2.17559 13.1993 2.48816 13.5118C2.80072 13.8244 3.22464 14 3.66667 14H10.3333C10.7754 14 11.1993 13.8244 11.5118 13.5118C11.8244 13.1993 12 12.7754 12 12.3333V3C12 2.81591 11.8508 2.66667 11.6667 2.66667H10ZM2.66667 3.33333V12.3333C2.66667 12.5986 2.77202 12.8529 2.95956 13.0404C3.1471 13.228 3.40145 13.3333 3.66667 13.3333H10.3333C10.5986 13.3333 10.8529 13.228 11.0404 13.0404C11.228 12.8529 11.3333 12.5986 11.3333 12.3333V3.33333H2.66667Z",
  fill: "#666666"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.66536 6C5.84946 6 5.9987 6.14924 5.9987 6.33333V10.3333C5.9987 10.5174 5.84946 10.6667 5.66536 10.6667C5.48127 10.6667 5.33203 10.5174 5.33203 10.3333V6.33333C5.33203 6.14924 5.48127 6 5.66536 6Z",
  fill: "#666666"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.33333 6C8.51743 6 8.66667 6.14924 8.66667 6.33333V10.3333C8.66667 10.5174 8.51743 10.6667 8.33333 10.6667C8.14924 10.6667 8 10.5174 8 10.3333V6.33333C8 6.14924 8.14924 6 8.33333 6Z",
  fill: "#666666"
});

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.02c95d50.svg";
export { ForwardRef as ReactComponent };